import { render } from "./DiamondManagementModal.vue?vue&type=template&id=21481837&scoped=true"
import script from "./DiamondManagementModal.vue?vue&type=script&lang=js"
export * from "./DiamondManagementModal.vue?vue&type=script&lang=js"

import "./DiamondManagementModal.vue?vue&type=style&index=0&id=21481837&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21481837"]])

export default __exports__